import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import BlockUtils from '../../Blocks/BlockUtils';

// Insert an info block into the editor.
export default class ToolInsertCalloutBlock extends Tool {
  static toolName = 'Callout box';
  static iconClass = 'fa-regular fa-info-circle';
  static type = 'infoBlock';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('infoBlock'));
  }

  static action({ editor, element }: ToolArgs): void {
    if (!editor) return;
    if (!editor.selection) return;

    BlockUtils.wrapBlocks(editor, this.type);
  }
}

class ToolInsertInfoBlock extends ToolInsertCalloutBlock {
  static toolName = 'Information';
  static iconClass = 'fa-regular fa-info-circle';
  static type = 'infoBlock';
}
class ToolInsertNoteBlock extends ToolInsertInfoBlock {
  static toolName = 'Note';
  static iconClass = 'fa-regular fa-pencil';
  static type = 'noteBlock';
}

class ToolInsertWarningBlock extends ToolInsertInfoBlock {
  static toolName = 'Warning';
  static iconClass = 'fa-regular fa-triangle-exclamation';
  static type = 'warningBlock';
}
class ToolInsertTipBlock extends ToolInsertInfoBlock {
  static toolName = 'Tip';
  static iconClass = 'fa-solid fa-wand-magic-sparkles';
  static type = 'tipBlock';
}

export {
  ToolInsertInfoBlock,
  ToolInsertNoteBlock,
  ToolInsertTipBlock,
  ToolInsertWarningBlock,
};
